// extracted by mini-css-extract-plugin
module.exports = {"mask":"mask--1d999","wrapper":"wrapper--7317a","wrapperBefore":"wrapperBefore--c44f4","loader":"loader--07231","spin":"spin--749ff"};